// quill's root entry point re-exports Quill but not Delta — the type lives on core.
import type { Delta } from 'quill/core'

/**
 * Quill's clipboard converter only treats block elements as line boundaries, so the newline that
 * follows a `<br>` in pretty-printed HTML survives as a leading space on the next line — which
 * indented every continuation line of a generated assessment summary (ENG-3937). Runs after
 * Quill's own text matcher, so at most one space is ever left to drop.
 */
export const stripFormattingSpaceAfterBreak = (node: Node, delta: Delta) => {
  const firstInsert = delta.ops[0]?.insert

  if (
    node.previousSibling?.nodeName === 'BR' &&
    typeof firstInsert === 'string' &&
    firstInsert.startsWith(' ')
  ) {
    return delta.slice(1)
  }

  return delta
}
